module.exports = __webpack_public_path__ + "img/Prisma.789048e4.jpg";